// ─── Gmail & API Configuration ─────────────────────────────────────────────
// Default: metadata only (From/To/Date). Ergode uses gmail.readonly via
// GET /token/oauth-config — never request readonly on the shared client.
export const GMAIL_SCOPES = 'https://www.googleapis.com/auth/gmail.metadata';
export const GMAIL_SCOPES_FULL = 'https://www.googleapis.com/auth/gmail.readonly';
// No GMAIL_API_BASE here any more: the browser never talks to Google directly.
// Gmail is reached through our backend proxy — see engine/gmailClient.js.

/**
 * sessionStorage key holding the OAuth `state` nonce between connect() and the
 * /google/callback redirect. Per-tab by design — GIS redirect mode navigates
 * the same tab, so the value survives the round trip to Google but is not
 * shared with any other tab or origin.
 */
export const OAUTH_STATE_KEY = 'ei_gmail_oauth_state';

/**
 * sessionStorage key for which OAuth client bucket was chosen at connect()
 * (default | ergode-1|2|3). Passed to /token/exchange so code exchange uses
 * the same client that initiated GIS — avoids fill-order race.
 */
export const OAUTH_CLIENT_KEY_STORAGE = 'ei_gmail_oauth_client_key';

/** Gmail API concurrent requests per batch (adaptive — shrinks on 429, recovers) */
export const BATCH_SIZE = 25;

/** Retry delay on 429 (ms) */
export const RATE_LIMIT_DELAY = 2000;

/** Default date range: last 7 days */
export const DEFAULT_DAYS = 7;

// ─── Claude Model ───────────────────────────────────────────────────────────
export const CLAUDE_MODEL = 'claude-haiku-4-5-20251001';
export const CLAUDE_API_URL = 'https://api.anthropic.com/v1/messages';
export const CLAUDE_MAX_TOKENS = 1024;

// ─── Delay threshold options ─────────────────────────────────────────────────
export const DELAY_THRESHOLDS = [
  { label: '> 1 min', value: 1 },
  { label: '> 5 mins', value: 5 },
  { label: '> 15 mins', value: 15 },
  { label: '> 30 mins', value: 30 },
  { label: '> 1 hour', value: 60 },
  { label: '> 4 hours', value: 240 },
  { label: '> 8 hours', value: 480 },
  { label: '> 24 hours', value: 1440 },
];
export const DEFAULT_DELAY_THRESHOLD = 5; // 5 mins

// ─── Communication Loop thresholds ──────────────────────────────────────────
/** Hours of inactivity after which a thread is considered "closed" */
export const LOOP_CLOSURE_HOURS = 48;

/** Aging buckets for pending loops (in hours) */
export const LOOP_AGE_BUCKETS = [
  { label: '< 24h', maxHours: 24, color: '#22c55e' },
  { label: '1–3 days', maxHours: 72, color: '#f59e0b' },
  { label: '3–7 days', maxHours: 168, color: '#ef4444' },
  { label: '> 7 days', maxHours: Infinity, color: '#dc2626' },
];

// ─── Quick-select presets ────────────────────────────────────────────────────
export const DATE_PRESETS = [
  { label: '7d', days: 7 },
  { label: '30d', days: 30 },
  { label: '90d', days: 90 },
];

// ─── Framer Motion animation variants ───────────────────────────────────────
export const FADE_UP = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: 'easeOut' } },
};

export const FADE_IN = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.35 } },
};

export const STAGGER_CONTAINER = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

export const SCALE_IN = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
};
